// extracted by mini-css-extract-plugin
export default {"meta":"styles_meta__onl-q","meta__description":"styles_meta__description__0plRq","meta__label":"styles_meta__label__B4ixN","meta__actions":"styles_meta__actions__GXMXL"};